import { render, staticRenderFns } from "./PostBlog-es.vue?vue&type=template&id=0b11c1dd&scoped=true&"
import script from "./PostBlog-es.vue?vue&type=script&lang=js&"
export * from "./PostBlog-es.vue?vue&type=script&lang=js&"
import style0 from "./PostBlog-es.vue?vue&type=style&index=0&id=0b11c1dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b11c1dd",
  null
  
)

export default component.exports